import { FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ManagerTarjetaDeCreditoService } from 'src/app/pago/services/manager-credit/manager-credit-card.service';

export class TarjetaDeCreditoFormValidators {
  static validarNumero(control: FormControl): ValidationErrors {
    if (control.value) {
      const numeroTarjetaDeCredito = control.value;

      const tipoTarjeta = ManagerTarjetaDeCreditoService.findTipoDeTarjeta(
        numeroTarjetaDeCredito
      );

      if (
        tipoTarjeta &&
        tipoTarjeta.validLength === numeroTarjetaDeCredito.length
      ) {
        return ManagerTarjetaDeCreditoService.validarNumero(
          numeroTarjetaDeCredito
        )
          ? null
          : { ERROR_CREDIT_CARD: true };
      } else {
        return { ERROR_CREDIT_CARD: true };
      }
    } else {
      return null;
    }
  }

  static codigoDeSeguridad(numeroTarjetaDeCredito: string): ValidatorFn {
    const validator: ValidatorFn = (control: FormControl): ValidationErrors => {
      if (control.value && numeroTarjetaDeCredito) {
        const tipoTarjeta = ManagerTarjetaDeCreditoService.findTipoDeTarjeta(
          numeroTarjetaDeCredito
        );

        return tipoTarjeta.validCvv !== control.value.length
          ? { ERROR_SECURITY_CODE: true }
          : null;
      } else {
        return null;
      }
    };
    return validator;
  }
}
